"use client"
import styled from "@emotion/styled"
import { TextField, Typography } from "@mui/material"

const StyledSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

const StyledInputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

const StyledInputRow = styled.div`
  display: flex;
  gap: 16px;
`

const StyledTextField = styled(TextField)`
  width: 100%;

  .MuiOutlinedInput-root {
    border-radius: 8px;
  }

  .MuiInputLabel-root {
    &.MuiInputLabel-shrink {
      background: white;
      padding: 0 4px;
    }
  }
`

interface InputGroupProps {
  title: string
  fromLabel: string
  toLabel: string
  fromPlaceholder: string
  toPlaceholder: string
  fromValue: string
  toValue: string
  onFromChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  onToChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  type?: string
  inputProps?: any
}

function InputGroup({
  title,
  fromLabel,
  toLabel,
  fromPlaceholder,
  toPlaceholder,
  fromValue,
  toValue,
  onFromChange,
  onToChange,
  type = "number",
  inputProps,
}: InputGroupProps) {
  return (
    <StyledSection>
      <Typography variant="body2" fontWeight={600}>
        {title}
      </Typography>
      <StyledInputGroup>
        <StyledInputRow>
          <StyledTextField
            label={fromLabel}
            placeholder={fromPlaceholder}
            variant="outlined"
            value={fromValue}
            onChange={onFromChange}
            type={type}
            inputProps={inputProps}
          />
          <StyledTextField
            label={toLabel}
            placeholder={toPlaceholder}
            variant="outlined"
            value={toValue}
            onChange={onToChange}
            type={type}
            inputProps={inputProps}
          />
        </StyledInputRow>
      </StyledInputGroup>
    </StyledSection>
  )
}

export default InputGroup
